package com.essntl.uikit.components.file

import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.essntl.features.file.domain.model.FileModel
import com.essntl.uikit.components.iconbutton.destructive.EsMediumDestructiveIconButton
import com.essntl.uikit.components.iconbutton.tinted.EsMediumTintedIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import com.mohamedrejeb.calf.io.KmpFile
import core.dateformat.ui.formatDate

@Composable
fun AttachmentCard(
    file: FileModel,
    date: String,
    description: String? = null,
    onDelete: () -> Unit,
    modifier: Modifier = Modifier,
) {
    var isFileViewerOpened by rememberSaveable { mutableStateOf(false) }

    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.SpaceBetween,
        modifier = modifier
            .clip(RoundedCornerShape(16.dp))
            .border(
                width = 1.dp,
                shape = RoundedCornerShape(16.dp),
                color = MaterialTheme.esColorScheme.borderPrimary,
            )
            .clickable {
                isFileViewerOpened = true
            }
            .fillMaxWidth()
            .padding(1.5f.spacing),
    ) {
        Row(
            horizontalArrangement = Arrangement.spacedBy(2.5f.spacing),
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier.weight(1f),
        ) {
            EsMediumTintedIconButton(
                iconRes = EsIcons.Attachment,
                onClick = {},
            )

            Column(
                horizontalAlignment = Alignment.Start,
                verticalArrangement = Arrangement.spacedBy(0.5f.spacing),
                modifier = Modifier.weight(1f),
            ) {
                Text(
                    text = file.name.orEmpty(),
                    style = MaterialTheme.esTypography.p1Medium16,
                    maxLines = 1,
                    modifier = Modifier.fillMaxWidth(),
                )

                Text(
                    text = description.orEmpty() + date.formatDate(),
                    style = MaterialTheme.esTypography.p2Regular14.copy(
                        color = MaterialTheme.esColorScheme.textSecondary,
                    ),
                    maxLines = 1,
                    modifier = Modifier.fillMaxWidth(),
                )
            }
        }

        EsMediumDestructiveIconButton(
            onClick = onDelete,
            iconRes = EsIcons.Trash,
            modifier = Modifier
                .padding(
                    top = 1.spacing,
                    end = 1.spacing,
                ),
        )
    }

    FileViewer(
        data = file.kmpFile ?: file.url,
        isDialogOpened = isFileViewerOpened,
        onDismissRequest = { isFileViewerOpened = false },
    )
}